import { NotificationConstants } from './constants'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage/session'

const persistConfig = {
  key: 'easeon_notifications',
  storage,
}

function notificationLocal(
  state = {
    notifications: [],
  },
  action
) {
  switch (action.type) {
    case NotificationConstants.ADD_NOTIFICATION:
      return {
        ...state,
        notifications: [...state.notifications, action.response],
      }
    case NotificationConstants.DELETE_ALL_NOTIFICATIONS: {
      return {
        ...state,
        notifications: [],
      }
    }
    default:
      return state
  }
}
export const notifications = persistReducer(persistConfig, notificationLocal)
